import {
    ClientRightsholder,
    StadiumFanAnalytics,
} from '../../../types/inVenue';
import { LeagueSeason } from '../../../types/api';
import useAnalytics from './useAnalytics';

type GameInput = {
    rightsholder: ClientRightsholder;
    season: LeagueSeason;
    clientId: number;
};

const useGameDates = ({ rightsholder, season, clientId }: GameInput) => {
    const { data: gameDates = [], isLoading } = useAnalytics({
        rightsholder,
        season,
        clientId,
        groupBy: ['date'],
    });

    const gameDatesArray = gameDates?.map(
        (d: StadiumFanAnalytics) => d.gameDate,
    );

    return { data: gameDatesArray, isLoading };
};

export default useGameDates;
